class BugsnagService {

  bugsnagExists() {
    return window.Bugsnag !== undefined && window.Bugsnag !== null;
  }

  notify(...args) {
    if (!this.bugsnagExists()) return;
    window.Bugsnag.notify(...args);
  }

  notifyException(...args) {
    if (!this.bugsnagExists()) return;
    window.Bugsnag.notifyException(...args);
  }

  setUser(userInfo) {
    if (!this.bugsnagExists()) return;
    window.Bugsnag.user = userInfo;
  }
}

export default BugsnagService;



// WEBPACK FOOTER //
// ./src/common/services/BugsnagService.js